export default {
  computed: {
    podeSolicitarAprovacao() {
      return this.edicao && this.contratoEdicao.passoGeral && this.possuiFluxoAprovacao
        && ((this.contratoEdicao.passoGeral.status === 'EM_CADASTRO' && this.solicitanteFluxo && this.possuiAcoesEmCadastro)
        || this.contratoEdicao.passoGeral.status === 'EM_ANALISE');
    },
    podeAprovar() {
      return this.edicao && this.contratoEdicao.passoGeral
        && this.contratoEdicao.passoGeral.status === 'AGUARDANDO_APROVACAO' && this.aprovadorFluxo;
    },
    podeFinalizar() {
      return this.edicao && this.contratoEdicao.passoGeral && !this.possuiFluxoAprovacao
        && this.contratoEdicao.passoGeral.status !== 'APROVADO';
    },
    possuiAcoesEmCadastro() {
      return this.contratoEdicao.passoAcoes.acoes && this.contratoEdicao.passoAcoes.acoes.length
        && this.contratoEdicao.passoAcoes.acoes.some((acao) => (acao.passoGeral && acao.passoGeral.status === 'EM_CADASTRO')
        || acao.status === 'EM_CADASTRO');
    },

  },
  methods: {
    exibicaoReprovarPersonalizada() {
      return true;
    },
  },
};
